import { Component } from 'react';

import PropTypes from 'prop-types';

import CustomIcon from '../../../common/CustomIcons';
import AccountCascadingRow from '../AccountCascadingRow';

import './styles/index.css';

class AccountCascadingDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      soldTosSelected: props.regSoldTos.filter(s => s.selected).length ? props.regSoldTos.filter(s => s.selected) : [{}]
    };
  }

  onSelection = (currentSelection, soldToIndex) => {
    const { handleAssociationSelection, regIndex, accIndex } = this.props;
    let soldTosSelected = [];
    this.setState(
      prevState => {
        soldTosSelected = [...prevState.soldTosSelected];
        soldTosSelected[soldToIndex] = { ...currentSelection };
        return { ...prevState, soldTosSelected };
      },
      () => {
        handleAssociationSelection(soldTosSelected, accIndex, regIndex);
      }
    );
  };

  handleAddRow = () => {
    this.setState(prevState => {
      const { soldTosSelected } = prevState;
      soldTosSelected.push({});
      return { ...prevState, soldTosSelected };
    });
  };

  deleteRow = index => {
    const { handleAssociationSelection, regIndex, accIndex } = this.props;
    this.setState(
      prevState => {
        const { soldTosSelected } = prevState;
        soldTosSelected.splice(index, 1);
        return { ...prevState, soldTosSelected };
      },
      () => {
        const { soldTosSelected: soldTosAfterDeletion } = this.state;
        handleAssociationSelection(soldTosAfterDeletion, accIndex, regIndex);
      }
    );
  };

  render() {
    const { soldTosSelected } = this.state;
    const { userAccAssocLabels, userAssociations } = this.props;
    const {
      missingCompanyName = '*Some values may be unavailable for selection due to missing company name in Cloud Craze data'
    } = userAccAssocLabels;
    const selectedSectionLength = soldTosSelected.length;
    const lastSection = selectedSectionLength ? soldTosSelected[selectedSectionLength - 1] : null;
    const disableAdd = lastSection ? Object.keys(lastSection).length === 0 : false;

    return (
      <>
        <h5 className="edit-account-info-area zeta">{missingCompanyName}</h5>
        {soldTosSelected.map((soldTo, index) => (
          <AccountCascadingRow
            key={index}
            soldTo={soldTo}
            soldToIndex={index}
            deleteRow={this.deleteRow}
            onSelection={this.onSelection}
            regSoldTos={userAssociations.soldTos}
            userAccAssocLabels={userAccAssocLabels}
          />
        ))}
        {!disableAdd && (
          <div className="rows-action">
            <div
              className="btn-wrap"
              onClick={() => this.handleAddRow()}
              onKeyUp={() => this.handleAddRow()}
              role="presentation"
            >
              <CustomIcon className="plus-circle-btn" type="plusCircled" size="18" />
            </div>
            <span className="zeta b">{userAccAssocLabels.addLine}</span>
          </div>
        )}
      </>
    );
  }
}

AccountCascadingDropdown.propTypes = {
  userAccAssocLabels: PropTypes.instanceOf(Object).isRequired,
  regSoldTos: PropTypes.instanceOf(Array),
  handleAssociationSelection: PropTypes.func.isRequired,
  regIndex: PropTypes.number.isRequired,
  accIndex: PropTypes.number.isRequired,
  userAssociations: PropTypes.instanceOf(Object).isRequired
};

AccountCascadingDropdown.defaultProps = {
  regSoldTos: []
};

export default AccountCascadingDropdown;
